import { Box, Paper, Stack, Typography } from '@mui/material'
import { FunctionComponent, useMemo } from 'react'

import { VehicleEntry, VehicleImageEntry } from '../../sdk'
import { describeVehicle } from '../../utils'

interface Props {
  vehicle: VehicleEntry
  vehicleImages: VehicleImageEntry[]
}

const VehicleInfoBoxForCustomer: FunctionComponent<Props> = ({
  vehicle,
  vehicleImages
}) => {
  const activeVehicleImage = useMemo(() => {
    return vehicleImages?.find((vehicleImage) => vehicleImage.info?.isPrimary)
  }, [vehicleImages])

  const vehicleDescription = (
    <Typography component="h3" variant="h4">
      {describeVehicle(vehicle.info!)}
    </Typography>
  )

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        boxSizing: 'border-box',
        height: '100%'
      }}>
      <Stack spacing={2} direction="row">
        {activeVehicleImage && (
          <Box>
            <img
              src={activeVehicleImage.info?.vehicleImageURL}
              alt="Vehicle Image"
              style={{
                maxWidth: 250,
                maxHeight: 250
              }}
            />
          </Box>
        )}
        {vehicle && (
          <Stack direction="column" spacing={1}>
            {vehicleDescription}
            <Typography>
              License Plate:{' '}
              {`${vehicle.info!.licensePlate || 'N/A'} - ${
                vehicle.info!.registeredState || 'N/A'
              }`}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Paper>
  )
}

export default VehicleInfoBoxForCustomer
